import styled, { css } from 'styled-components';
import { SCREEN_SIZE } from '../../grid';
import { SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiFamilyPrimaryName, FontAddiWeightMedium } from '@addi/foundation/dist/web/fonts';
import { ColorAddiFontPrimary, ColorAddiCompFourLighten2, ColorAddiGrayLighten3, ColorAddiFontStrong, ColorAddiBackgroundSoft, ColorAddiCompFiveLighten4, ColorAddiPrimaryActive } from '@addi/foundation/dist/web/colors';
export const InputContainer = styled.input `
    width: 40px;
    height: 50px;
    outline: none;
    margin-right: ${({ index }) => index === 2 ? '30' : '10'}px;
    text-align: center;
    color: ${ColorAddiFontPrimary};

    font-size: ${SizeAddiFontSmall};
    font-weight: ${FontAddiWeightMedium};
    line-height: 21px;
    font-family: ${FontAddiFamilyPrimaryName};

    border-radius: 3px;
    border: solid 1px ${({ isInvalid }) => isInvalid
    ? ColorAddiCompFourLighten2
    : ColorAddiGrayLighten3};

    ${({ controlledMode }) => controlledMode && css `pointer-events: none;`}

    &:hover {
        background-color: ${ColorAddiCompFiveLighten4};
    }

    &:focus {
        width: 38px;
        height: 48px;
        border-width: 2px;
        ${({ isInvalid }) => !isInvalid && `border-color: ${ColorAddiPrimaryActive}`}
    }

    &:disabled {
        color: ${ColorAddiFontStrong};
        background-color: ${ColorAddiBackgroundSoft};
    }

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        width: 35px;
        height: 45px;
        margin-right: ${({ index }) => index === 2 ? '20' : '6'}px;

        &:focus {
            width: 33px;
            height: 43px;
            border-width: 2px;
            ${({ isInvalid }) => !isInvalid && `border-color: ${ColorAddiPrimaryActive}`}
        }
    }
`;
//# sourceMappingURL=InputContainer.Styled.js.map